import { PublisherWebsiteStatus, PublisherWebsiteStatusMap } from 'respona_api/generated/common_pb';
import { SvgIconType } from '@uikit/old/Icon/Icon';
import {
  DRAFT_BG_COLOR,
  DRAFT_TEXT_COLOR,
  PRIMARY_COLOR,
  WARNING_COLOR,
  WARNING_LIGHT_BG_COLOR,
  WHITE_COLOR,
} from '@constants/colors';

export type PublisherWebsiteStatusValue =
  PublisherWebsiteStatusMap[keyof PublisherWebsiteStatusMap];

export type WebsiteStatusConfig = {
  label: string;
  bg: string;
  text: string;
  icon: SvgIconType;
  iconColor: string;
  tooltip: string;
  /** Status the toggle switches to when clicked. */
  nextStatus: PublisherWebsiteStatusValue;
};

const ACTIVATE_TOOLTIP = 'Click to activate the website';

/**
 * Mirrors the Concierge "Campaigns" status pill (Draft / In progress / Paused): imported
 * websites land as drafts, so the table has to say so instead of showing a bare switch.
 * `PW_INACTIVE` is what the backend calls a paused website.
 */
export const WEBSITE_STATUS_CONFIG: Record<PublisherWebsiteStatusValue, WebsiteStatusConfig> = {
  [PublisherWebsiteStatus.PW_DRAFT]: {
    label: 'Draft',
    bg: DRAFT_BG_COLOR,
    text: DRAFT_TEXT_COLOR,
    icon: 'lightningArrow',
    iconColor: WHITE_COLOR,
    tooltip: ACTIVATE_TOOLTIP,
    nextStatus: PublisherWebsiteStatus.PW_ACTIVE,
  },
  [PublisherWebsiteStatus.PW_ACTIVE]: {
    label: 'Active',
    bg: PRIMARY_COLOR,
    text: WHITE_COLOR,
    icon: 'pauseIcon',
    iconColor: PRIMARY_COLOR,
    tooltip: 'Click to pause the website',
    nextStatus: PublisherWebsiteStatus.PW_INACTIVE,
  },
  [PublisherWebsiteStatus.PW_INACTIVE]: {
    label: 'Paused',
    bg: WARNING_LIGHT_BG_COLOR,
    text: WARNING_COLOR,
    icon: 'playArrow',
    iconColor: WHITE_COLOR,
    tooltip: ACTIVATE_TOOLTIP,
    nextStatus: PublisherWebsiteStatus.PW_ACTIVE,
  },
};

export const getWebsiteStatusConfig = (status: PublisherWebsiteStatusValue): WebsiteStatusConfig =>
  WEBSITE_STATUS_CONFIG[status] || WEBSITE_STATUS_CONFIG[PublisherWebsiteStatus.PW_DRAFT];

export const WEBSITE_VERIFIED_TOOLTIP_ID_PREFIX = 'website-verified-';
